export class InventoryCountSummaryTPVDto {
    section: string;
    gender: string;
    quantityQuantum: number;
    quantityTPV: number;
    sections: string[];
}
